let HOLD_WIP_SERVER_URL = 'http://localhost:8090/api';
let UNSECURE_SERVER_URL = 'http://localhost:8090';

//let USER_SERVICE_URL = 'http://localhost:8081/api/user';
//let USER_SERVICE_TOKEN_URL = 'http://localhost:8081/oauth/token';

let USER_SERVICE_URL = 'https://userservice-stg.orbiscorporation.com/userservice/api/user';
let USER_SERVICE_TOKEN_URL = 'https://userservice.orbiscorporation.com/userservice/oauth/token';


if (process.env.NODE_ENV === 'stage') {

    HOLD_WIP_SERVER_URL = '/api';
    UNSECURE_SERVER_URL = '';

    USER_SERVICE_URL = 'https://userservice-stg.orbiscorporation.com/userservice/api/user';
    USER_SERVICE_TOKEN_URL = 'https://userservice-stg.orbiscorporation.com/userservice/oauth/token';
}

if (process.env.NODE_ENV === 'production') {
    HOLD_WIP_SERVER_URL = '/holdwip/api';
    UNSECURE_SERVER_URL = '';

    USER_SERVICE_URL = 'https://userservice.orbiscorporation.com/userservice/api/user';
    USER_SERVICE_TOKEN_URL = 'https://userservice.orbiscorporation.com/userservice/oauth/token';
}

export { HOLD_WIP_SERVER_URL, UNSECURE_SERVER_URL, USER_SERVICE_URL, USER_SERVICE_TOKEN_URL }
